import Permissions, { usePermissions } from '@app/src/auth/permissions'
import type { NavigationItemProps } from '@app/src/components/Navigation/VerticalMenu/NavigationItems/NavigationItems'
import { Solutions } from '@app/src/wf-constants'
import navigationLinks from '@app/src/wf-constants/navigationLinks'
import React from 'react'
import { useIntl } from 'react-intl'
import type { MenuWrapperProps } from './MenuWrapper'
import MenuWrapper from './MenuWrapper'

const ProviderMenu: React.FC<NavigationItemProps> = ({ icon }) => {
  const { formatMessage } = useIntl()
  const { getWithPermission } = usePermissions()

  const solution = getWithPermission({
    [Permissions.SOURCING_USER]: Solutions.Sourcing,
    [Permissions.INVESTMENT_USER]: Solutions.Investment,
    [Permissions.FINANCE_USER]: Solutions.Finance,
  })

  if (!solution) {
    return null
  }

  const menuItems: MenuWrapperProps['menuItems'] = [
    {
      title: formatMessage({ id: 'navbar.companies' }),
      link: navigationLinks.providers,
      permission: [Permissions.SOURCING_USER, Permissions.FINANCE_USER, Permissions.INVESTMENT_USER],
    },
    { title: formatMessage({ id: 'navbar.contacts' }), link: navigationLinks.contacts },
  ]

  return (
    <MenuWrapper
      icon={icon}
      menuItems={menuItems}
      activePaths={['/resource/']}
      title={formatMessage({ id: `navbar.${solution}` })}
    />
  )
}

export default ProviderMenu
